import { memo } from "react";
import {
  Box,
  Typography,
  styled,
} from "@mui/material";

// Types
type CardGenerateVideoFinalVideoProps = {
  videoUrl: string;
};

// Styles
const Card = styled(Box)({
  backgroundColor: "white",
  borderRadius: "0.75rem",
  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  border: "1px solid #e2e8f0",
  padding: "1.5rem",
  marginBottom: "1.5rem",
});

// Main Component
const CardGenerateVideoFinalVideo = (props: CardGenerateVideoFinalVideoProps) => {

  return (
    <Card id="megen-final-video-root">
      <Typography id="megen-final-video-title" sx={{ fontSize: "1.125rem", fontWeight: 600, color: "#1e293b", mb: 2 }}>
        Final Output
      </Typography>
      <video
        id="megen-final-video-player"
        controls
        style={{ width: "100%", borderRadius: "0.5rem", backgroundColor: "black", aspectRatio: "16 / 9" }}
        src={props.videoUrl}
      />
    </Card>
  );
};

CardGenerateVideoFinalVideo.displayName = "CardGenerateVideoFinalVideo";

export default memo(CardGenerateVideoFinalVideo);